import { render, staticRenderFns } from "./BaseOptionKeyHint.vue?vue&type=template&id=5b9ceed2&"
import script from "./BaseOptionKeyHint.vue?vue&type=script&lang=ts&"
export * from "./BaseOptionKeyHint.vue?vue&type=script&lang=ts&"
import style0 from "./BaseOptionKeyHint.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports